package pwgs.ui.scenes.projectrootscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AProjectRootControllerFe(props: pwgs.ui.scenes.projectrootscene.ProjectRootSceneProps, scene: MProjectRootScene)
 : AController<pwgs.ui.scenes.projectrootscene.ProjectRootSceneProps, pwgs.ui.scenes.projectrootscene.ProjectRootSceneModel, ProjectRootSceneState>(props, scene) {

    val backend = ProjectRootControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class ProjectRootControllerBeProxy(private val controller: AProjectRootControllerFe) {

    suspend fun load(): pwgs.ui.scenes.projectrootscene.ProjectRootSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.projectrootscene.ProjectRootControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.projectrootscene.ProjectRootSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.projectrootscene.ProjectRootSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.projectrootscene.ProjectRootSceneModel.serializer())
        }
    }

}
